import React from "react";
import { Link } from "react-router-dom";

export default function Header(){
  return (
    <header className="nav">
      <div className="container row">
        <div className="brand">
          <span className="wordmark">Soft Tech Talks</span>
        </div>
        <nav className="links">
          <Link to="/" className="byline" style={{marginLeft:18,textDecoration:"none",color:"inherit"}}>Home</Link>
<Link to="/library" className="byline" style={{marginLeft:18,textDecoration:"none",color:"inherit"}}>Libraries</Link>
          <Link to="/about" className="byline" style={{marginLeft:18,textDecoration:"none",color:"inherit"}}>About</Link>
        </nav>
      </div>
    </header>
  );
}